<template>
  <section class="section">
    <div class="split">
      <div>
        <h2>Mobile-First and Built for Kenya</h2>
        <ul class="bullets">
          <li>Works on your phone</li>
          <li>No app download needed - fully web-based</li>
        </ul>
      </div>

      <div>
        <h2>Payments Integration</h2>
        <ul class="bullets">
          <li>M-Pesa integration (coming soon)</li>
          <li>Entry fee collection per team</li>
          <li>Payment tracking dashboard (coming soon)</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style scoped>
.section {
  padding: 1.5rem 0 0.85rem;
}

.split {
  display: grid;
  gap: 1rem;
}

h2 {
  margin: 0 0 0.6rem;
  font-size: 1.35rem;
  color: var(--text-color1);
  font-weight: 800;
}

.bullets {
  margin: 0;
  padding-left: 1.1rem;
  color: var(--text-color1);
  opacity: 0.9;
}

.bullets li + li {
  margin-top: 0.5rem;
}

.split > div {
  background: var(--background-color2);
  border: 1px solid var(--border-color-hover1, #e5e7eb);
  border-radius: 16px;
  padding: 1rem;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
}

@media (min-width: 900px) {
  .split {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
